import { render, staticRenderFns } from "./FlussiViewComponent.vue?vue&type=template&id=1881a687"
import script from "./FlussiViewComponent.vue?vue&type=script&lang=js"
export * from "./FlussiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports